export default "__VITE_ASSET__u77rZ1pb__"